import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Select,
  Text,
  VStack,
  Heading,
  useToast,
  Container,
  Flex,
  Divider,
  HStack,
} from "@chakra-ui/react";
import { HamburgerIcon    } from "@chakra-ui/icons";
import { MdTableChart } from 'react-icons/md'; 
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Label,
  ReferenceLine,
} from "recharts";
import html2canvas from "html2canvas";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
} from "@chakra-ui/react";
import jsPDF from "jspdf";
import { getForecast, GetInventoryListing,addManualForecast} from "../service/ForecastService";
import { FieldValue } from "../constants/Types";
import { getValue } from "@testing-library/user-event/dist/utils";

interface ForecastDashboardProps {
  onClose: () => void;
  onOpenAdvanced: () => void;
}

const ForecastDashboard: React.FC<ForecastDashboardProps> = ({
  onClose,
  onOpenAdvanced,
}) => {
  const [forecastData, setForecastData] = useState<any>(null);
  const [dataByDate, setDataByDate] = useState<any[]>([]);
  //const [lastHistoricalDate, setlastHistoricalDate] = useState<any[]>([]);
  const [lastHistoricalDate, setlastHistoricalDate] = useState<string | null>(null);

  const [historicalData, sethistoricalData] = useState<any[]>([]);
  const [selectedItem, setSelectedItem] = useState("");
  const [itemOptions, setItemOptions] = useState<FieldValue[]>([]);
  const toast = useToast();
   const [isTableView, setIsTableView] = useState(false);
  const chartRef = useRef<HTMLDivElement>(null);

const handleOpenWordFile = () => {
    const fileUrl = "/InventoryForecastingReadME.pdf";
    window.open(fileUrl, '_blank');
  };

  useEffect(() => {
    const fetchItems = async () => {
      try {
        const result = await GetInventoryListing();
        setItemOptions(result);
      } catch (error) {
        toast({
          title: "Failed to load inventory items",
          status: "error",
          isClosable: true,
        });
        setItemOptions([]);
      }
    };
    fetchItems();
  }, []);

  useEffect(() => {
    if (!selectedItem) {
      setForecastData(null);
      setDataByDate([]);
      sethistoricalData([]);
     // setlastHistoricalDate([]);
// ✅ set to null when there's no valid date
//setLastHistoricalDate(null);

      return;
    }

    getForecast(selectedItem)
      .then((data) => {
        if (data.result && data.dataByDate && data.weeklyData) {
          const forecast = Array.isArray(data.result)
             ? data.result.find((f: any) => f.itemId === selectedItem)
            : null;
          setForecastData(forecast || null);
          setDataByDate(Array.isArray(data.dataByDate) ? data.dataByDate : []);
          sethistoricalData(Array.isArray(data.weeklyData) ? data.weeklyData : []);
        } else {
          const forecast = Array.isArray(data)
            ? data.find((f: any) => f.itemId === selectedItem)
            : null;
          setForecastData(forecast || null);
          setDataByDate([]);
          sethistoricalData([]);
        }
      })
      .catch(() => {
        toast({ title: "Failed to fetch forecast", status: "error" });
        setForecastData(null);
        setDataByDate([]);
        sethistoricalData([]);
      });
  }, [selectedItem]);

  
// const getMergedChartData = () => {
 
//     if (!forecastData || !forecastData.forecastedQuantities) return [];

//     const historical = historicalData.map((item: any) => ({
//       date: item.date?.split("T")[0],
//       quantityAvailable: item.quantityAvailable ?? null,
//       forecasted: null,
//     }));

//     const lastDateStr = historical[historical.length - 1]?.date;
//     const lastDate = lastDateStr ? new Date(lastDateStr) : new Date();

// const lastHistorical = historical[historical.length - 1];

// const bridgePoint = {
//   date: lastHistorical.date,
//   quantityAvailable: lastHistorical.quantityAvailable,
//   forecasted: lastHistorical.quantityAvailable, // same value to bridge
// };
// ;
//     const forecasted = forecastData.forecastedQuantities.map(
//   (val: { foreCastedDate: string; qty: number }) => {
//     return {
//       date: val.foreCastedDate.split("T")[0],
//       quantityAvailable: null,
//       forecasted: val.qty,
//     };
//   }
// );
//     return [...historical, bridgePoint, ...forecasted];
//   };

//v1
const getMergedChartData = () => {
  if (!forecastData || !forecastData.forecastedQuantities) return [];

  const historical = historicalData.map((item: any) => ({
    date: item.date?.split("T")[0],
    quantity: item.quantityAvailable ?? null,
  }));

 // const lastHistorical = historical[historical.length - 1];
//const lastHistorical = historical[historical.length - 1]?.quantity ?? null;
const lastHistoricalDate = historical[historical.length - 1]?.date ?? null;


  const forecasted = forecastData.forecastedQuantities.map(
    (val: { foreCastedDate: string; qty: number }) => ({
      date: val.foreCastedDate.split("T")[0],
      quantity: val.qty,
    })
  );
 // ✅ Combine both arrays into one and return
  // const mergedChartData = [...historical, ...forecasted];

  // return mergedChartData;

 return [...historical,...forecasted];
};

const handleSaveQtyChange = (index : number) => {
console.log(selectedItem,forecastData.forecastedQuantities[index].foreCastedDate,forecastData.forecastedQuantities[index].qty);
  addManualForecast(selectedItem,forecastData.forecastedQuantities[index].foreCastedDate,forecastData.forecastedQuantities[index].qty)
}
const handleQtyChange = (index : number, newQty :number) => {
//console.log(selectedItem,forecastData.forecastedQuantities[index].foreCastedDate,newQty);
 // addManualForecast(selectedItem,forecastData.forecastedQuantities[index].foreCastedDate,newQty)

 const updatedForecastedQuantities = forecastData.forecastedQuantities.map((item :any , i :number) => {
      if (i === index) {
        return {
          ...item,
          qty: newQty//parseInt(newQty || 0, 10)
        };
      }
      return item;
    });

    // Update the whole forecastData object
    setForecastData({
      ...forecastData,
      forecastedQuantities: updatedForecastedQuantities
    });


  };
  const downloadPDF = async () => {
    if (!chartRef.current) return;
    const canvas = await html2canvas(chartRef.current);
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF();
    pdf.addImage(imgData, "PNG", 10, 10, 180, 90);
    pdf.save("forecast-report.pdf");
  };

  const handleDownloadJSON = () => {
    if (!dataByDate.length) return;
    const blob = new Blob([JSON.stringify(dataByDate, null, 2)], {
      type: "application/json",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "dataByDate.json";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleDownloadCSV = () => {
    if (!dataByDate.length) return;
    const keys = Object.keys(dataByDate[0]);
    const csvRows = [
      keys.join(","),
      ...dataByDate.map((row: any) =>
        keys
          .map((k) => {
            let value = row[k];
            if (
              typeof value === "string" &&
              (value.includes(",") || value.includes('"'))
            ) {
              value = `"${value.replace(/"/g, '""')}"`;
            }
            return value;
          })
          .join(",")
      ),
    ];

    const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "dataByDate.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };
//const { mergedData, lastHistoricalDate } = getMergedChartData() || { mergedData: [], lastHistoricalDate: null };

  return (
    <Container maxW="100%" py={6}>
      <Heading size="lg" mb={4}>
        📦 Inventory Forecast
      </Heading>
      <Box mt={4} textAlign="right">
        <Button
          size="sm"
          variant="link"
          colorScheme="blue"
         onClick={handleOpenWordFile}
        >
          Read Me
        </Button>       
      </Box>


      <Flex wrap="wrap" gap={4} mb={6} align="center">
        <Select
          placeholder="Select Item"
          width="250px"
          value={selectedItem}
          onChange={(e) => setSelectedItem(e.target.value)}
        >
          {itemOptions.map((item) => (
            <option key={item.value} value={item.value}>
              {item.value}
            </option>
          ))}
        </Select>
        <Text>
          Select an item to view its 13-week forecast.( Based on previous 13 weeks data.)
        </Text>
      </Flex>
      <Box mt={4}>
        <Button
          size="sm"
          variant="link"
          colorScheme="blue"
          leftIcon={<HamburgerIcon />}
          onClick={() => setIsTableView(!isTableView)}
        >
          Table View
        </Button>
      </Box>
      <Divider mb={4} />

      {/* Merged Historical + Forecasted Chart */}
      {/* {forecastData && dataByDate.length > 0 && (
        <Box
          ref={chartRef}
          p={4}
          borderWidth={1}
          borderRadius="lg"
          bg="white"
          shadow="md"
          mt={6}
        > */}
          {/* <Text fontWeight="bold" mb={2}>
            📈 Quantity Available: Historical + Forecast
          </Text> */}
          {/* <ResponsiveContainer width="100%" height={400}>
            <LineChart data={getMergedChartData()}>
              <CartesianGrid strokeDasharray="3 3" />
              
              <XAxis dataKey="date" angle={-45} textAnchor="end" height={100}>
                <Label value="Date" position="insideBottom"/>
              </XAxis>
              <YAxis>
                <Label angle={-90} value="Quantity Available" position="insideLeft" />
              </YAxis>
              <Tooltip />
              <Legend 
                layout="horizontal"
                verticalAlign="top"
                align="right"
              />
              <Line
                type="monotone"
                dataKey="quantityAvailable"
                stroke="#3182CE"
                name="Historical"
                dot={{ r: 2 }}
              />
              <Line
                type="monotone"
                dataKey="forecasted" ="quantityAvailable"
                stroke="#2F855A"
                strokeDasharray="5 5"
                name="Forecasted"
                dot={{ r: 2 }}
              />
            </LineChart>
          </ResponsiveContainer> */}
          {/* v1 */}
           {/* Merged Historical + Forecasted Chart */}
      {/* {forecastData && dataByDate.length > 0 && ( */}

        {forecastData && getMergedChartData().length > 0 && (

        <Box
          ref={chartRef}
          p={4}
          borderWidth={1}
          borderRadius="lg"
          bg="white"
          shadow="md"
          mt={6}
        >
 {  isTableView ? (
          <ResponsiveContainer width="100%" >
             <Table variant="simple" size="sm">
                   <Thead>
                     <Tr><Th>
                Date</Th><Th>Qunatity</Th><Th></Th></Tr></Thead>
<Tbody>
                 {forecastData.forecastedQuantities.map((item :any ,index :number) => (
                  <Tr key ={"forecast_"+ index}><Td>{item.foreCastedDate?.split("T")[0]} </Td>
                  <Td>
                  <input
                type="number"
                value={item.qty}
                onChange={(e) => handleQtyChange(index, parseFloat(e.target.value))}
                style={{ width: '80px' }}
              /> </Td>
              <Td> <Button
          size="sm"
          variant="link"
          colorScheme="blue"
          onClick={() => handleSaveQtyChange(index)}
        >
         save
        </Button></Td>
                  </Tr>
                    
                  ))}
       </Tbody>                   </Table>
            </ResponsiveContainer>
 ):(
    
          <ResponsiveContainer width="100%" height={400}>
              <LineChart data={getMergedChartData()}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" angle={-45} textAnchor="end" height={100}>
                  <Label value="Date" position="insideBottom" />
                </XAxis>
                <YAxis>
                  <Label angle={-90} value="Quantity" position="insideLeft" />
                </YAxis>
                <Tooltip />
                <Legend layout="horizontal" verticalAlign="top" align="right" />
               
                <Line
                  type="monotone"
                  dataKey="quantity"
                  stroke="#2B6CB0"
                  name="Historical + Forecasted"
                  dot={{ r: 2 }}
                />
                
                {/* <ReferenceLine
                     //y="40400"
                     x="2025-07-25"
                     //x={lastHistoricalDate as string}
                      stroke="#8d1e28ff"
                     // strokeDasharray="3 3"
                      label="Forecast begins"
                      ifOverflow="extendDomain"
                />  */}
              
              </LineChart>
          </ResponsiveContainer>
 )}
        </Box>
      )}

      {/* Download Buttons & Advanced Forecasting */}
      {dataByDate.length > 0 && (
        <Box mt={4} p={4} borderWidth={1} borderRadius="md" bg="gray.50">
          {/* <Text fontWeight="bold" mb={2}>
            Download Data
          </Text> */}
          <HStack spacing={4}>
            <Button size="sm" colorScheme="green" onClick={handleDownloadCSV}>
              Download CSV
            </Button>
            <Button size="sm" colorScheme="orange" onClick={handleDownloadJSON}>
              Download JSON
            </Button>
            <Button size="sm" colorScheme="blue" onClick={downloadPDF}>
              Download PDF
            </Button>
          </HStack>
        </Box>
      )}
      <Box mt={4}>
        <Button
          size="sm"
          variant="link"
          colorScheme="blue"
          onClick={onOpenAdvanced}
        >
          ← Back to Forecast Selection
        </Button>
      </Box>
    </Container>
  );
};

export default ForecastDashboard;
